module.exports = __webpack_public_path__ + "static/media/library.cc682807.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/photography/library.jpg
// module id = 721
// module chunks = 0